// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Palestine from '../_raw/flag/icon_flag_palestine.png';

export default () => <img src={Palestine} alt="Palestine" />;
